import React from 'react';

import { Box } from '@mui/material';

import { PageLayout } from 'src/components/common';
import { EmployeeMyVerifyForm } from 'src/components/consumer';
import { useScreenInfo } from 'src/hooks/common';
import { UnfreezeYourAccountModal } from 'src/modals/consumer';
import type { SxProp } from 'src/types/mui';

export const MyVerifyPage: React.FC = () => {
  const { isMobile } = useScreenInfo();

  if (isMobile) {
    return (
      <Box sx={mobileContentWrapperStyles}>
        <EmployeeMyVerifyForm />

        <UnfreezeYourAccountModal />
      </Box>
    );
  }

  return (
    <PageLayout titleContent="My Verify">
      <EmployeeMyVerifyForm />

      <UnfreezeYourAccountModal />
    </PageLayout>
  );
};

const mobileContentWrapperStyles: SxProp = {
  zIndex: '1',
  position: 'relative',
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  p: 2,
  pt: 0,
};
